import api from './api';

export interface MobileQuickAction {
  id: string;
  title: string;
  icon?: string;
  route?: string;
}

export const mobileApi = {
  getNavigation: async () => api.get('/mobile/navigation'),
  postGesture: async (data: { type: string; payload?: any }) => api.post('/mobile/gestures', data),
  getQuickActions: async () => api.get<MobileQuickAction[]>('/mobile/quick-actions'),
};

export default mobileApi;


